import { IDeleteAcaoPrevCorretivasUseCase } from "../../../presentation/useCases/delete/delete_acao_preventivas_corretivas_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// DeleteAcaoPrevCorretivasUseCase


export class DeleteAcaoPrevCorretivasUseCase implements IDeleteAcaoPrevCorretivasUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async deleteAcaoPrevCorretivas(IdAcaoPrevCorretiva: number, IdAcaoQualidade: number,): Promise<void> {
    
    await this.repository.deleteAcaoPrevCorretivas( IdAcaoPrevCorretiva, IdAcaoQualidade);
  }
}
